export default {"src":"/_next/static/media/icon-three.e8b57802.svg","height":22,"width":22};